// Node
import i18next from 'i18next';

// Custom
import i18CustomParams from "../../../new_design/common/i18_custom";
import GlobalForm from "../../../new_design/common/search_widget/search_form/global.js";
import MdcCheckBox from "../../mdc_checkbox.js.jsx";
import $ from "jquery";

export default class SearchDesktop extends React.Component {
  constructor(props) {
    super(props);

    this.formId = 'searchForm';
    this.defaultChildAge = 8;
  }

  async componentDidMount () {
    const form = await GlobalForm.init(this.formId);
    await i18next.init(i18CustomParams(), function(err, t) {});
    form?.guestsWidget?.syncInflection?.();
  }

  render() {
    return (
      <form id={this.formId} className="favorite-search">
        <div className="favorite-search__request">
          <div className="search-item search-item__date">
            <input type="hidden" name="date_start" id="date_start" defaultValue={this.props.date_start} />
            <input type="hidden" name="date_end" id="date_end" defaultValue={this.props.date_end} />
            <input type="hidden" name="count_guests" id="count_guests" max={25} min={1} value={this.props.adults_count} />
            <input type="hidden" name="children_count" id="children_count" max={10} value={this.props.children_count} />

            <div className="search-wrapper">
              <div className="icon-books_black icon-books_black-dims"></div>
              <div className="search-item__date_calendar">
                <input
                    type="text"
                    name="dates"
                    defaultValue={this.props.dates_range || ''}
                    className="search-item__input range"
                    placeholder="Даты поездки"
                    id="dates"
                    readOnly
                    autoComplete="off"
                />
                <input
                    type="text"
                    name="nights_count"
                    id="nights_count"
                    className="search-item__input nights"
                    readOnly
                    autoComplete="off"
                />
              </div>
            </div>
          </div>


          <div className="search-item search-item__guest">
            <div className="search-wrapper">
              <div className="search-icon"></div>

              <input
                  type="text"
                  name="total_adults_count"
                  id="total_adults_count"
                  value={this.props.adults_count}
                  className="search-item__input counter adult_pair"
                  readOnly
                  autoComplete="off"
              />
              <input
                  type="text"
                  className="search-item__input adult adult_pair"
                  readOnly
                  autoComplete="off"
              />
              <input
                  type="text"
                  name="total_children_count"
                  id="total_children_count"
                  value={this.props.children_count}
                  className="search-item__input counter child_pair"
                  readOnly
                  autoComplete="off"
              />
              <input
                  type="text"
                  className="search-item__input child child_pair"
                  readOnly
                  autoComplete="off"
              />
              <input
                  type="text"
                  value="питомец"
                  className="search-item__input pet"
                  readOnly
                  autoComplete="off"
                  style={{ display: this.props.with_pet ? 'block' : 'none' }}
              />

              <div className="guest search-drop">
                <div className="guest-wrap">
                  <div className="guest-line">
                    <div className="guest-line__title">
                      Взрослые
                    </div>

                    <div className="guest-line__count">
                      <div className={`less guest-line__count-btn ${this.props.count_guests > 0 ? '' : 'guest-line__count-btn_disable'}`}
                           data-target_input="count_guests">
                        <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1H15" stroke="#DADADA" stroke-width="2" stroke-linecap="square" />
                        </svg>
                      </div>

                      <div className="guest-line__count-numb">
                        {this.props.adults_count}
                      </div>

                      <div className="more guest-line__count-btn"
                           data-target_input="count_guests">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 1V15" stroke="#00C853" stroke-width="2" stroke-linecap="square" />
                          <path d="M15 8H1" stroke="#00C853" stroke-width="2" stroke-linecap="square" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="guest-line">
                    <div className="guest-line__title">
                      Дети
                    </div>

                    <div className="guest-line__count">
                      <div className={`less guest-line__count-btn ${this.props.children_count > 0 ? '' : 'guest-line__count-btn_disable'}`}
                           data-target_input="children_count">
                        <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1H15" stroke="#DADADA" stroke-width="2" stroke-linecap="square" />
                        </svg>
                      </div>

                      <div className="guest-line__count-numb">
                        {this.props.children_count}
                      </div>

                      <div className="more guest-line__count-btn"
                           data-target_input="children_count">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 1V15" stroke="#00C853" stroke-width="2" stroke-linecap="square" />
                          <path d="M15 8H1" stroke="#00C853" stroke-width="2" stroke-linecap="square" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="guest-child" style={{ display: this.props.children_ages.length > 0 ? 'block' : 'none' }}>
                    <div className="guest-child__title">
                      Возраст детей
                    </div>

                    <div className="guest-child__input"
                         data-default_age={this.defaultChildAge}
                         id="children_ages" data-ages={this.props.children_ages}>
                    </div>
                  </div>

                  <MdcCheckBox
                      label="Путешествую с питомцем"
                      labelFor="with_pet"
                      checked={this.props.with_pet}
                      className="with_pet_checkbox"
                      id="with_pet"
                  />
                </div>

                <span id="closeGuestsModal" className="btn date-btn__item date-btn__item_left">
                Применить
              </span>
              </div>
            </div>
          </div>
        </div>

        <input type="submit"
               value="Показать"
               id="search_button"
               className="btn_form" />
      </form>
    );
  }
}
